import React from 'react';
import cn from 'classnames';

import Autopay from 'account/Autopay';
import SmsNotifications from '../../account/SmsNotifications';

import styles from './index.module.css'

export const Account = () => (
  <div className={cn('Account', styles.wrapper)}>
    <h2 className={styles.title}>Autopay</h2>
    <Autopay />
    <SmsNotifications />
  </div>
);

export default Account;
